"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var EditorTypes_1 = require("../EditorTypes");
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var CopyActions = __importStar(require("./CopyActions"));
var IsDomElement_1 = require("Utils/IsDomElement/IsDomElement");
exports.default = (function (di) {
    return {
        copyFromTable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Copy from a table")
            .isEvent(EditorTypes_1.EventType.Copy)
            .inTableCell()
            .selectionIsExpanded()
            .doAction(function (event, editor) {
            event.preventDefault();
            CopyActions.copyFromNestedStructure(event, editor);
            return true;
        }),
        dragFromTable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Drag from a table")
            .isEvent(EditorTypes_1.EventType.DragStart)
            .inTableCell()
            .selectionIsExpanded()
            .doAction(function (event, editor) {
            event.preventDefault();
            return true;
        }),
        cutFromTable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Cut from a table")
            .isEvent(EditorTypes_1.EventType.Cut)
            .inTableCell()
            .selectionIsExpanded()
            .doAction(function (event, editor) {
            event.preventDefault();
            CopyActions.cutFromNestedStructure(event, editor);
            return true;
        }),
        copyTable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Copy table")
            .isEvent(EditorTypes_1.EventType.Copy)
            .inTableDummy()
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.copyTable(event, editor).handled;
        }),
        cutTable: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Cut table")
            .isEvent(EditorTypes_1.EventType.Cut)
            .inTableDummy()
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.cutTable(event, editor).handled;
        }),
        copyFromSideBySide: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Copy from a side by side")
            .isEvent(EditorTypes_1.EventType.Copy)
            .isOfAncestry(EditorTypes_1.BlockType.SideBySideColumn)
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.copyFromNestedStructure(event, editor);
        }),
        cutFromSideBySide: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Cut from a side by side")
            .isEvent(EditorTypes_1.EventType.Cut)
            .isOfAncestry(EditorTypes_1.BlockType.SideBySideColumn)
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.cutFromNestedStructure(event, editor);
        }),
        copyFromAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Copy from an accordion")
            .isEvent(EditorTypes_1.EventType.Copy)
            .isOfAncestry([EditorTypes_1.BlockType.AccordionHeading, EditorTypes_1.BlockType.AccordionBody])
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.copyFromNestedStructure(event, editor);
        }),
        cutFromAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Cut from an accordion")
            .isEvent(EditorTypes_1.EventType.Cut)
            .isOfAncestry([EditorTypes_1.BlockType.AccordionHeading, EditorTypes_1.BlockType.AccordionBody])
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.cutFromNestedStructure(event, editor);
        }),
        copySideBySide: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Copy side by side")
            .isEvent(EditorTypes_1.EventType.Copy)
            .inBlockType(EditorTypes_1.BlockType.SideBySideDummy)
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.copySideBySide(event, editor).handled;
        }),
        cutSideBySide: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Cut side by side")
            .isEvent(EditorTypes_1.EventType.Cut)
            .inBlockType(EditorTypes_1.BlockType.SideBySideDummy)
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.cutSideBySide(event, editor);
        }),
        dragText: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Drag text")
            .isEvent(EditorTypes_1.EventType.DragStart)
            .doAction(function (event, editor) {
            if (!event.target || !(0, IsDomElement_1.isDOMElement)(event.target)) {
                return;
            }
            var hasTargetTagName = event.target.tagName && event.target.tagName.toUpperCase;
            if (hasTargetTagName && event.target.tagName.toUpperCase() !== "IMG") {
                event.preventDefault();
                return true;
            }
            else {
                return;
            }
        }),
        copyWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Copy widget")
            .isEvent(EditorTypes_1.EventType.Copy)
            .inBlockType([
            EditorTypes_1.BlockType.Image,
            EditorTypes_1.BlockType.Video,
            EditorTypes_1.BlockType.GoogleMaps,
            EditorTypes_1.BlockType.Iframe,
            EditorTypes_1.BlockType.Button,
            EditorTypes_1.BlockType.ROICalculator,
        ])
            .doAction(function (event, editor) {
            event.preventDefault();
            CopyActions.copyWidget(event, editor);
            return true;
        }),
        cutWidget: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Cut widget")
            .isEvent(EditorTypes_1.EventType.Cut)
            .inBlockType([
            EditorTypes_1.BlockType.Image,
            EditorTypes_1.BlockType.Video,
            EditorTypes_1.BlockType.GoogleMaps,
            EditorTypes_1.BlockType.Iframe,
            EditorTypes_1.BlockType.HorizontalRule,
            EditorTypes_1.BlockType.Button,
            EditorTypes_1.BlockType.ROICalculator,
        ])
            .doAction(function (event, editor) {
            event.preventDefault();
            CopyActions.cutWidget(event, editor);
            return true;
        }),
        copyAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Copy accordion")
            .isEvent(EditorTypes_1.EventType.Copy)
            .inBlockType(EditorTypes_1.BlockType.AccordionDummy)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.copyAccordion(event, editor).handled;
        }),
        cutAccordion: di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("Cut accordion")
            .isEvent(EditorTypes_1.EventType.Cut)
            .inBlockType(EditorTypes_1.BlockType.AccordionDummy)
            .selectionIsCollapsed()
            .doAction(function (event, editor) {
            event.preventDefault();
            return CopyActions.cutAccordion(event, editor);
        }),
    };
});
